import { BaseModel } from './base.model';

export class AcademicYear extends BaseModel {
  id: string;
  key: number;
  name: string;
  academicSegmentId: string;
  academicSegment: object;
}
